/* Addlore cart drawer — LOGIC ONLY.
   19-09-2026: split out of snippets/adl-cart-drawer.liquid. That snippet shipped 35 KB of
   JavaScript inline in every page's HTML, which the browser had to parse before it could
   paint. DebugBear measured the document itself at 9.00 s of CPU and the hero image sitting
   downloaded for ~2 s before it was drawn. The DATA (which needs Liquid) stays inline and is
   handed over on window.ADL_CART; this file is static, cacheable, and loaded with `defer`,
   so it is parsed off the critical path and still runs before DOMContentLoaded — the
   DOMContentLoaded handler at the bottom therefore fires exactly as it did before. */
(function(){
  var B = window.ADL_CART || {};
  var ADL = B.ADL, GIFTVARIANTS = B.GIFTVARIANTS, GIFTS = B.GIFTS, P = B.P;
  function byHandle(h){ return P.filter(function(p){ return p.handle === h; })[0]; }

  var $ = function(s,r){ return (r||document).querySelector(s); };
  var root = $('#adlCartDrawer'), body = $('#adlCartBody'),
      QVEL = $('#adlQV'), QVS = $('#adlQVSheet');
  var CART = null, NOTE = null, LAST = null, QV = null, OPEN = true, BUSY = false, MANUAL = false;

  function money(p){ return '&#8377;' + Math.round(p/100).toLocaleString('en-IN'); }
  function sv(d,w){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="'+(w||1.7)+'" stroke-linecap="round" stroke-linejoin="round">'+d+'</svg>'; }
  var X = sv('<path d="M5 5l14 14M19 5L5 19"/>',1.5),
      TICK = sv('<path d="M20 7 9.5 17.5 4 12"/>',2.4),
      CHEV = sv('<path d="M6 15l6-6 6 6"/>',2.2),
      TRASH = sv('<path d="M4 7h16M9.5 7V5h5v2M6.5 7l1 13h9l1-13M10.5 11v6M13.5 11v6"/>',1.6),
      LOCK = sv('<rect x="4.5" y="10.5" width="15" height="10" rx="2.5"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/>',1.6),
      FLEUR = sv('<path d="M12 3.2c2.4 1.9 3.6 4 3.6 6.3 0 2.4-1.6 4.3-3.6 6.1-2-1.8-3.6-3.7-3.6-6.1 0-2.3 1.2-4.4 3.6-6.3Z"/><path d="M12 15.6v5.2M9.6 19h4.8"/>',1.5),
      IC_POUCH = sv('<path d="M6 8.5h12l1.3 10.8a1.6 1.6 0 0 1-1.6 1.7H6.3a1.6 1.6 0 0 1-1.6-1.7L6 8.5Z"/><path d="M6 8.5V6.8A1.8 1.8 0 0 1 7.8 5h8.4A1.8 1.8 0 0 1 18 6.8v1.7"/><path d="M9.8 12.4h4.4"/>',1.8),
      IC_SHEET = sv('<path d="M5 4.5h14v9.5L13.5 19.5H5z"/><path d="M19 14h-5.5v5.5"/><circle cx="12" cy="9.5" r="2.6"/>',2),
      IC_TIN = sv('<rect x="3.5" y="7.5" width="17" height="9.5" rx="3.2"/><path d="M3.5 11.4h17"/><path d="M12 13.6v1.6"/>',1.8),
      IC_CASH = sv('<rect x="2.5" y="6" width="19" height="12" rx="2.5"/><circle cx="12" cy="12" r="2.6"/>',1.5),
      IC_BOX = sv('<path d="M3.5 7.5 12 3.5l8.5 4v9L12 20.5 3.5 16.5z"/><path d="M3.5 7.5 12 11.5l8.5-4M12 11.5v9"/>',1.5);

  /* The four sticker-sheet photographs, referenced by filename with no ?v=
     cache key so a re-upload of the same name is picked up without an edit
     here. The 1100px adl-gift-sheet-<key>.jpg versions exist for anywhere
     bigger than these thumbnails. */
  var GIFTIMG = 'https://cdn.shopify.com/s/files/1/0781/7573/1999/files/adl-gift-stickers-';
  var GIFTSHEETNAME = { pleasured:'Pleasured', moonlit:'Moonlit', spirited:'Spirited', mix:'Addlore mix' };
  /* Per-flavour record art, TILE crop: the disc masked to its own circle on
     an ink ground, so it survives being 23px wide. The white-ground
     adl-gift-record-<key>.jpg is the version for anywhere big (the PDP
     dialog); do not use it here. Only Pleasured's exists; a key that is
     absent falls back to the ink card rather than borrowing another
     flavour's label. */
  var RECIMG = { pleasured:'https://cdn.shopify.com/s/files/1/0781/7573/1999/files/adl-gift-record-tile.jpg' };
  /* The inside of one .stk box. Both gifts are photographs where the art
     exists: the sticker gift shows the sheet the cart has earned, and the
     playlist card shows that flavour's record. Shared by gi() and gcards()
     so all three render sites agree. */
  function gart(g){
    var key = giftKey();
    if(g.k === 'a')
      return '<img src="'+GIFTIMG+key+'.jpg" alt="The '+(GIFTSHEETNAME[key]||'Addlore mix')+' sticker sheet" loading="lazy">';
    if(g.k === 'b')
      return RECIMG[key]
        ? '<img src="'+RECIMG[key]+'" alt="The '+GIFTSHEETNAME[key]+' playlist record" loading="lazy">'
        : '';                       /* the CSS blank record above shows through */
    return '<span>'+g.t+'</span>';
  }
  function gi(g,cls){ return '<span class="'+(cls||'')+' stk '+g.k+'" style="transform:rotate('+g.rot+'deg)">'+gart(g)+'</span>'; }
  function G(cls){ return GIFTS.map(function(g){ return gi(g,cls); }).join(''); }
  function gcards(){
    return '<div class="gcards">'+GIFTS.map(function(g){
      return '<figure><span class="stk '+g.k+'" style="transform:rotate('+g.rot+'deg)">'+gart(g)+'</span>'+
        '<figcaption>'+g.cap+'</figcaption></figure>'; }).join('')+'</div>';
  }

  var UID = 0;
  function stars(handle, showCount){
    if(!ADL.demoReviews) return '';
    var d = ADL.reviews[handle]; if(!d) return '';
    var rt = d[0], rc = d[1], S = '';
    for(var i=1;i<=5;i++){
      var f = rt>=i ? 1 : (rt>i-1 ? rt-(i-1) : 0), id = 'adlst'+(++UID);
      S += '<svg viewBox="0 0 20 20">'+
        (f>0&&f<1 ? '<defs><linearGradient id="'+id+'"><stop offset="'+(f*100)+'%" stop-color="#1A1A1A"/><stop offset="'+(f*100)+'%" stop-color="rgba(29,27,24,.25)"/></linearGradient></defs>' : '')+
        '<path d="M10 1.6l2.5 5.4 5.9.7-4.4 4 1.2 5.8L10 14.6 4.8 17.5 6 11.7 1.6 7.7l5.9-.7z" fill="'+
        (f>=1 ? 'currentColor' : (f>0 ? 'url(#'+id+')' : 'rgba(29,27,24,.25)'))+'"/></svg>';
    }
    return '<span class="rev">'+S+(showCount ? '<b>'+rt.toFixed(1)+'</b><em>'+rc+' reviews</em>' : '<span>'+rt.toFixed(1)+'</span>')+'</span>';
  }

  /* ---------------------------------------------------------------
     MONEY. Totals always come from /cart.js. The table above only
     answers what the NEXT tin costs.
     --------------------------------------------------------------- */
  function tins(){
    return CART ? CART.items.reduce(function(a,i){
      /* The ₹0 free-gift line is a fulfilment instruction, not a tin.
         Counting it made a 3-tin cart say "4 tins", "4-tin price" and
         "4 TINS · 64 SQUARES" — every one of those reads this number. */
      if(GIFTVARIANTS.indexOf(i.variant_id) > -1) return a;
      return a + i.quantity * (/2\s*tins/i.test(i.variant_title||'') ? 2 : 1); },0) : 0;
  }
  /* The distinct products the TIN lines belong to — the handle with its
     -v2 suffix stripped, once each, with the ₹0 gift line skipped. One
     source of truth for "how many flavours are in this cart", so isMixed()
     and giftKey() can never disagree about the answer. */
  function tinHandles(){
    if(!CART) return [];
    var seen = [];
    CART.items.forEach(function(i){
      if(GIFTVARIANTS.indexOf(i.variant_id) > -1) return;
      var h = String(i.handle||'').replace(/^addlores-|-v2$/g,'');
      if(seen.indexOf(h) === -1) seen.push(h);
    });
    return seen;
  }
  /* True when the cart holds more than one FLAVOUR. Shopify's automatic
     discount allocates its saving proportionally across lines, so in a
     mixed cart no single line's own price matches the "next tin costs ₹X"
     story on its own — see rowHTML() and ledger().
     This used to read CART.items.length > 1, which counted LINES, and was
     wrong twice over. Two separate lines of the same product read as a mix
     of flavours. And from 06-09-2026 the ₹0 gift line is itself a line, so
     every single-flavour cart of two or more tins started reading as mixed
     — putting a "you're saving ₹X mixing flavours" banner and a mix & match
     pill on a cart with only one flavour in it. Count flavours, not lines,
     and leave the gift line out of the count. */
  function isMixed(){ return tinHandles().length > 1; }
  /* Which of the four sticker sheets this cart earns, as a key for the
     photograph filenames. The founder's rule: two tins of one flavour bring
     that flavour's sheet, two tins of different flavours bring the Addlore
     mix sheet. Same flavour count as isMixed(), but it needs the flavour's
     name and not just how many there are. An empty cart falls back to the
     mix sheet, the safe generic, as does an unrecognised handle. Keep this
     in step with the sheet snippets/adl-gift-cart.liquid actually adds. */
  function giftKey(){
    var seen = tinHandles();
    if(seen.length !== 1) return 'mix';
    return GIFTSHEETNAME[seen[0]] ? seen[0] : 'mix';
  }
  /* What the Nth tin costs — the marginal step of the real ladder. */
  function tinPrice(i){
    var T = ADL.ladderTotals;
    if(i > 0 && i < T.length) return T[i] - T[i-1];
    return ADL.tailStep;
  }
  function cartTotal(){ return CART ? CART.total_price : 0; }
  function cartMrp(){
    return CART.items.reduce(function(a,i){
      return a + (i.original_line_price>i.final_line_price ? i.original_line_price : i.final_line_price); },0);
  }
  function linePaid(idx, it){ return it.final_line_price; }
  function lineMrp(idx, it){ return it.original_line_price > it.final_line_price ? it.original_line_price : 0; }

  /* ---------------------------------------------------------------
     THE PRICE HOLD. A real per-session deadline kept in sessionStorage,
     so it does not restart on refresh. When it runs out the chip says so
     and the offer stops quoting a countdown.
     --------------------------------------------------------------- */
  function holdEnd(){
    if(!ADL.holdMinutes) return 0;
    var k='adlHoldEnd', v=0;
    try{ v = +(sessionStorage.getItem(k)||0);
      if(!v){ v = Date.now() + ADL.holdMinutes*60000; sessionStorage.setItem(k, v); }
    }catch(e){ v = Date.now() + ADL.holdMinutes*60000; }
    return v;
  }
  function holdChip(){
    if(!ADL.holdMinutes) return '';
    var ms = holdEnd() - Date.now();
    if(ms <= 0) return '<span class="timer done">This price is still here</span>';
    var s=Math.floor(ms/1000), m=Math.floor(s/60), ss=s%60;
    return '<span class="timer">This price held &middot; <b>'+m+':'+(ss<10?'0':'')+ss+'</b></span>';
  }

  /* ---------------------------------------------------------------
     SCOREBOARD — three rungs, always. The third is labelled with the
     price it actually unlocks.
     --------------------------------------------------------------- */
  function score(){
    var c = tins(), st = [c>=1, c>=ADL.giftAt, c>=ADL.thirdAt], done = st.filter(Boolean).length;
    var third = 'Third tin '+money(tinPrice(3));
    var L = [{b:'Free shipping', s:st[0]?'Unlocked':'Every order', i:IC_POUCH},
             {b:'Free gifts',    s:st[1]?'Unlocked':ADL.giftAt+' tins', i:IC_SHEET},
             {b:third,           s:st[2]?'Unlocked':ADL.thirdAt+' tins', i:IC_TIN}];
    var gap = c===0 ? 'Two tins unlocks <b>the free gifts</b>'
      : c===1 ? '<b>'+money(tinPrice(2))+' more</b> unlocks the free gifts'
      : c===2 ? '<b>'+money(tinPrice(3))+' more</b> and the third tin is yours'
      : 'Everything unlocked.';
    var pucks = [16.667,50,83.333].map(function(pos,i){
      return '<span class="puck'+(st[i]?' on':'')+'" style="left:'+pos+'%">'+L[i].i+'</span>'; }).join('');
    var marks = L.map(function(m,i){ return '<div'+(st[i]?' class="on"':'')+'><b>'+m.b+'</b><s>'+m.s+'</s></div>'; }).join('');
    var gapRow = c < ADL.giftAt
      ? '<button class="gapline" data-adl="gifts"><span class="gs">'+G('gt')+'</span><span class="tx">'+gap+'</span><span class="arw">&rsaquo;</span></button>'
      : '<span class="gap">'+gap+'</span>';
    return '<div class="score"><div class="gtrack"><span class="gfill" style="width:'+(done*100/3).toFixed(2)+'%"></span>'+
      pucks+'</div><div class="gmarks">'+marks+'</div>'+gapRow+'</div>';
  }

  /* ---------------------------------------------------------------
     THE OFFER — one per state, never two.
     --------------------------------------------------------------- */
  function prodCard(p, single){
    var bd = '<span class="nm">'+(p.short||p.title)+'</span><span class="ds">'+(p.ds||'')+'</span>'+stars(p.handle);
    return '<div class="prod" data-adl="qv" data-h="'+p.handle+'"><img src="'+p.img+'" alt="'+p.title+' tin">'+
      (single ? '<div class="wr">'+bd+'</div>' : bd)+
      '<button class="add" data-adl="add" data-v="'+p.vid+'">add+</button></div>';
  }
  function xsell(){
    var c = tins();
    if(c >= ADL.thirdAt) return '';
    if(c === 0){
      return '<div class="box"><p class="lede"><span class="big">Three chocolates.</span>'+
        '<span class="sub">'+money(tinPrice(1))+' each &middot; free shipping on every order</span></p>'+
        '<div class="grid">'+P.map(function(p){ return prodCard(p); }).join('')+'</div></div>';
    }
    var next = tinPrice(c+1), word = (c===1 ? 'second' : 'third');
    var h = CART.items.map(function(i){ return i.handle; });
    var missing = P.filter(function(p){ return h.indexOf(p.handle) === -1; });
    var single = (c === ADL.giftAt && missing.length === 1);
    var big, sub, list;
    if(single){
      big = 'The third tin is '+money(next)+'.';
      sub = 'Only '+(missing[0].short||missing[0].title)+' left';
      list = missing;
    } else {
      big = 'The '+word+' tin is '+money(next)+'.';
      sub = 'Any flavour. Same price.';
      var first = byHandle(h[0]);
      list = (first ? [first] : []).concat(P.filter(function(p){ return p.handle !== h[0]; }));
    }
    if(!OPEN){
      return '<button class="mini" data-adl="expand">'+holdChip()+
        '<span class="thumbs">'+list.slice(0,3).map(function(p){ return '<img src="'+p.img+'" alt="'+p.title+'">'; }).join('')+'</span>'+
        '<span class="tx"><b>'+big.replace('.','')+'</b><s>'+(c<ADL.giftAt ? 'and the free gifts' : sub)+'</s></span>'+
        '<span class="open">see</span></button>';
    }
    return '<div class="box">'+holdChip()+
      '<button class="fold" data-adl="collapse" aria-label="Collapse the offer">'+CHEV+'</button>'+
      '<p class="lede"><span class="big">'+big+'</span><span class="sub">'+sub+'</span></p>'+
      '<div class="grid'+(single?' one':'')+'">'+list.map(function(p){ return prodCard(p, single); }).join('')+'</div></div>';
  }

  /* ---------------------------------------------------------------
     LINE ITEMS, GIFTS ROW, LEDGER
     --------------------------------------------------------------- */
  function thumb(u){ return u ? (u.indexOf('?')>-1 ? u+'&width=168' : u+'?width=168') : ''; }
  /* Keeps the ₹0 gift line out of the row list. giftRow() below is the
     drawer's own designed representation of the gifts; drawing the raw line
     as well would say it twice and, worse, hand the customer a −/1/+
     stepper and a remove button for a gift they never chose and cannot add
     back themselves. rowHTML()'s stepper is untouched — it just never sees
     a gift line. */
  function notGift(it){ return GIFTVARIANTS.indexOf(it.variant_id) === -1; }
  function rowHTML(it, i){
    var p = byHandle(it.handle) || {};
    var mixed = isMixed();
    var mrp, paid, sub, mixTag = false;
    if(mixed){
      /* A mixed cart's per-line Shopify price is a proportional slice of
         the whole cart's discount, so on its own it never matches the
         "next tin costs ₹X" promise (e.g. a lone new-flavour line can
         read ₹566 against a ₹400 promise). Show the plain, true price on
         every line instead — the one real saving is stated once, in
         ledger()'s "Mix & match discount applied" row. */
      mrp = 0;
      paid = it.original_line_price;
      sub = p.vr || it.variant_title || '';
      mixTag = true;
    } else if(it.quantity >= 2){
      /* One product, several tins, one line — Shopify already gives this
         a single correct lump total, so keep showing it. Just label it
         plainly as a bundle instead of leaving the old static "16
         squares" subtitle, which didn't scale with quantity. */
      mrp = lineMrp(i, it);
      paid = linePaid(i, it);
      sub = it.quantity+' tins (bundle) &middot; '+(it.quantity*16)+' squares';
    } else {
      mrp = lineMrp(i, it);
      paid = linePaid(i, it);
      sub = p.vr || it.variant_title || '';
    }
    return '<div class="row"><span class="rowhit" data-adl="qv" data-h="'+it.handle+'" style="display:contents">'+
      '<img src="'+thumb(it.image)+'" alt="'+it.product_title+' tin">'+
      '<span><span class="nm">'+(p.short || p.title || it.product_title)+'</span><span class="vr">'+sub+'</span></span></span>'+
      '<div class="tools"><span class="pr">'+(mixTag?'<i>'+TICK+'</i>':(mrp?'<s>'+money(mrp)+'</s>':''))+'<b>'+money(paid)+'</b></span>'+
      '<span class="ln"><span class="qty">'+
        '<button data-adl="dec" data-k="'+it.key+'" data-q="'+it.quantity+'" aria-label="Reduce"'+(it.quantity<=1?' disabled':'')+'>&minus;</button>'+
        '<output>'+it.quantity+'</output>'+
        '<button data-adl="inc" data-k="'+it.key+'" data-q="'+it.quantity+'" aria-label="Increase">+</button></span>'+
      '<button class="rm" data-adl="rm" data-k="'+it.key+'" aria-label="Remove">'+TRASH+'</button></span></div></div>';
  }
  /* The banner under the scoreboard — only when the cart is mixed. Only
     ever states a fact that is true right now (the amount saved) — it
     never claims the cart has hit a "promised" price, because for most
     of the cart's life (e.g. 2 tins, still being pitched a third) no
     such promise has been made yet, and saying "locked in" then directly
     above an active upsell to add more was contradicting itself.
     Eighth pass: leads with the plain fact ("Discount applied") before
     the brand term ("mixing flavours") — a first-time visitor doesn't
     know what "Mix & match" means yet, the fact should land regardless.
     At the finish line (every rung unlocked, no offer card left) it
     switches to a distinct dark "all unlocked" treatment instead of
     repeating the same pill every other tier gets — see finishLine(). */
  function mixBanner(){
    if(!isMixed()) return '';
    var saved = cartMrp() - cartTotal();
    if(saved <= 0) return '';
    if(tins() >= ADL.thirdAt){
      return '<div class="mixbanner finish">'+TICK+'Everything unlocked &mdash; you saved '+money(saved)+' mixing flavours</div>';
    }
    return '<div class="mixbanner">'+TICK+'Discount applied &mdash; you\'re saving '+money(saved)+' mixing flavours</div>';
  }
  /* Sits where the offer card used to be, once the offer card has
     nothing left to pitch (mixed cart, every rung unlocked). Founder-
     approved mockup, addressing the "3-tin finish line reads exactly
     like every other state" note. */
  function finishLine(){
    if(!isMixed() || tins() < ADL.thirdAt) return '';
    return '<div class="finishline"><b>Nothing left to unlock</b><span>Every reward is already in this box</span></div>';
  }
  function giftRow(){
    if(tins() < ADL.giftAt) return '';
    return '<div class="row gifted" data-adl="gifts"><span class="gtrio">'+G('')+'</span>'+
      '<span><span class="nm">The gifts</span><span class="vr">Stickers &middot; the playlist</span>'+
      '<span class="see">Tap to see them</span></span>'+
      '<div class="tools"><span class="free">Free</span></div></div>';
  }
  function ledger(){
    var c = tins(), chips = '', seen = {};
    function chip(t, raw){
      var name = raw || ((ADL.publicCodes||[]).indexOf(String(t||'').toUpperCase())>-1 ? t : 'Offer applied');
      if(seen[name]) return; seen[name]=1;
      chips += '<span>'+TICK+name+'</span>';
    }
    (CART.cart_level_discount_applications||[]).forEach(function(d){ chip(d.title); });
    CART.items.forEach(function(it){ (it.line_level_discount_allocations||[]).forEach(function(d){ chip(d.discount_application.title); }); });
    if(c>=2) chip(null, c+'-tin price');
    if(c>=ADL.giftAt) chip(null,'Free gifts');
    chip(null,'Free shipping');
    /* True subtotal — the sum of what every line would cost with no
       discount at all. CART.items_subtotal_price already nets out the
       per-line discount on this store, so using it here made "Subtotal
       minus Discounts" not actually land on the real total. This does. */
    var trueSubtotal = CART.items.reduce(function(a,it){ return a + it.original_line_price; }, 0);
    var disc = CART.total_discount;
    return '<div class="led">'+
      '<div class="r"><span>Subtotal</span><span class="v">'+money(trueSubtotal)+'</span></div>'+
      (disc>0 ? '<div class="r"><span>Discounts</span><span class="v ok">&minus;'+money(disc)+'</span></div>' : '')+
      '<div class="r"><span>Shipping</span><span class="v ok">Free</span></div>'+
      '<div class="r"><span>Taxes</span><span class="v" style="font-weight:400;color:var(--mute)">Included</span></div>'+
      '<span class="applied">Already applied</span><div class="tags">'+chips+'</div></div>';
  }
  function fud(){
    return '<div class="fud"><div>'+IC_POUCH+'<span>Free shipping,<br>every order</span></div>'+
      '<div>'+IC_CASH+'<span>Cash on delivery,<br>pay &#8377;99 now</span></div>'+
      '<div>'+IC_BOX+'<span>Discreet pouch,<br>ships in 24 hrs</span></div></div>';
  }

  /* ---------------------------------------------------------------
     SHEET — the gifts, and the whole product without leaving the cart
     --------------------------------------------------------------- */
  function sheet(){
    if(!QV){ QVEL.classList.remove('on'); QVS.innerHTML=''; return; }
    var html;
    if(QV === 'gifts'){
      html = '<div class="grab"><i></i><button class="qx" data-adl="qvclose" aria-label="Close">'+X+'</button></div>'+
        '<div class="sbody"><h3>The gifts</h3><span class="fo">Free with '+ADL.giftAt+' tins</span>'+
        '<p class="slede">Both arrive in the box. Nothing on the outside says what is inside.</p>'+
        gcards()+
        GIFTS.map(function(g){ return '<div class="gitem"><b>'+g.nm+'</b><p>'+g.d+'</p></div>'; }).join('')+
        '</div>'+
        '<div class="buy"><span class="note2">'+(tins()>=ADL.giftAt ? 'Yours &mdash; already in the box' : 'Add a second tin to unlock')+'</span>'+
        '<button data-adl="qvclose" style="flex:0 0 auto;padding:0 26px">close</button></div>';
    } else {
      var p = byHandle(QV); if(!p){ QV=null; return; }
      var imgs = (p.imgs && p.imgs.length) ? p.imgs : [p.img];
      var next = tinPrice(tins()+1) || tinPrice(1);
      html = '<div class="grab"><i></i><button class="qx" data-adl="qvclose" aria-label="Close">'+X+'</button></div>'+
        '<div class="sbody"><div class="shot">'+
        '<div class="gal" id="adlGal">'+imgs.map(function(u,i){ return '<img src="'+u+'" alt="'+p.title+', view '+(i+1)+'">'; }).join('')+'</div>'+
        (imgs.length>1 ? '<button class="gnav prev" data-dir="-1" aria-label="Previous">&lsaquo;</button>'+
                         '<button class="gnav next" data-dir="1" aria-label="Next">&rsaquo;</button>' : '')+
        '</div>'+
        (imgs.length>1 ? '<div class="dots">'+imgs.map(function(u,i){ return '<i class="'+(i===0?'on':'')+'"></i>'; }).join('')+'</div>' : '')+
        '<h3>'+p.title+'</h3><span class="fo">'+(p.ds||'')+'</span>'+stars(p.handle,true)+
        (p.lede ? '<p class="slede">'+p.lede+'</p>' : '')+
        (p.act ? '<span class="eb">What is in it</span>'+
          p.act.map(function(a){ return '<div class="dose"><b>'+a[0]+'</b><span>'+a[1]+'</span></div>'; }).join('') : '')+
        '<div class="facts"><span>'+(p.cocoa||'')+' cocoa</span><span>16 squares</span><span>80 g</span>'+
        '<span>Bean to bar</span><span>NABL tested</span></div></div>'+
        '<div class="buy"><span class="p"><b>'+money(next)+'</b>'+
          (p.cap>p.price ? '<s>'+money(p.cap)+'</s>' : '')+'</span>'+
        '<button data-adl="add" data-v="'+p.vid+'">add+</button></div>';
    }
    QVS.innerHTML = html;
    QVEL.classList.add('on');
  }

  /* ---------------------------------------------------------------
     RENDER
     --------------------------------------------------------------- */
  function render(){
    if(!CART){ body.innerHTML=''; return; }
    var c = tins(), t = cartTotal(), mrp = cartMrp(), saved = mrp - t;
    var head = '<div class="hdr">'+FLEUR+'<h2>Your cart'+(c?'<i>'+c+' tin'+(c>1?'s':'')+'</i>':'')+'</h2>'+
      '<button class="x" data-adl="close" aria-label="Close">'+X+'</button></div>'+
      score()+(NOTE?'<div class="note">'+NOTE+'</div>':'')+mixBanner();
    if(!c){
      body.innerHTML = head+'<div class="body"><div class="empty"><span class="big">Nothing in here yet.</span>'+
        '<span class="sub">Two tins brings the stickers and the playlist.</span></div>'+
        xsell()+'</div><div class="ft">'+fud()+'</div>';
      sheet(); return;
    }
    var x = xsell() || finishLine();
    body.innerHTML = head+
      '<div class="body">'+CART.items.filter(notGift).map(rowHTML).join('')+giftRow()+ledger()+'</div>'+
      (x ? '<div class="pinned">'+x+'</div>' : '')+
      '<div class="ft">'+
        '<div class="totrow"><span><span class="eb">'+c+' tin'+(c>1?'s':'')+' &middot; '+(c*16)+' squares</span>'+
        (saved>0 ? '<span class="sv">saved '+money(saved)+'</span>' : '')+'</span>'+
        '<span class="amt"><b>'+money(t)+'</b>'+(saved>0?'<s>'+money(mrp)+'</s>':'')+'</span></div>'+
        '<button class="go" type="submit" name="checkout" form="adlCartCheckout">'+LOCK+'checkout</button>'+
        '<label class="news"><input type="checkbox" checked><span>Keep me posted on offers</span></label>'+
        fud()+
      '</div>';
    sheet();
    /* collapse the offer only when the cart is genuinely squeezed */
    if(!MANUAL && OPEN && c >= 2){
      var probe = $('.body', body);
      if(probe && probe.scrollHeight - probe.clientHeight > 8){ OPEN = false; render(); }
    }
  }
  setInterval(function(){
    if(!root.classList.contains('open') || !ADL.holdMinutes) return;
    var el = $('.timer', body); if(!el) return;
    var ms = holdEnd() - Date.now();
    if(ms <= 0){ el.className='timer done'; el.innerHTML='This price is still here'; return; }
    var s=Math.floor(ms/1000), m=Math.floor(s/60), ss=s%60;
    var b = $('b', el); if(b) b.textContent = m+':'+(ss<10?'0':'')+ss;
  },1000);

  /* ---------------------------------------------------------------
     CART API
     --------------------------------------------------------------- */
  function load(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();}).then(function(c){ CART=c; render(); }); }
  function change(k,q){ if(BUSY) return Promise.resolve(); BUSY=true;
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:k,quantity:q})})
      .then(function(r){return r.json();}).then(function(c){ CART=c; BUSY=false; render(); bubble(); announce(); }); }
  function add(id,qty){ if(BUSY) return Promise.resolve(); BUSY=true;
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:qty||1}]})})
      .then(function(){ BUSY=false; return load().then(function(){ bubble(); announce(); }); }); }
  function bubble(){ var b=document.querySelector('#cart-icon-bubble'); if(b&&CART) b.setAttribute('data-count',CART.item_count); }
  /* 25-09-2026: spoken confirmation of a cart change. Silent for sighted users; it is the only
     feedback a screen-reader user gets that add-to-cart did anything. */
  function announce(){ var l=document.getElementById('adlCartLive'); if(!l||!CART) return;
    var n=CART.item_count;
    l.textContent = n ? ('Cart updated. '+n+' item'+(n>1?'s':'')+' in your cart.') : 'Your cart is now empty.'; }
  function open(){ root.classList.add('open'); document.documentElement.style.overflow='hidden'; load(); }
  function close(){ root.classList.remove('open'); document.documentElement.style.overflow=''; QV=null; }

  /* ---------------------------------------------------------------
     EVENTS
     --------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble, [data-adl-open]');
    if(trigger && !e.target.closest('.adlcd')){ e.preventDefault(); open(); return; }

    /* gallery arrows scroll the strip — they never re-render */
    var g = e.target.closest('[data-dir]');
    if(g){
      var gal = $('#adlGal');
      if(gal){ var im = gal.querySelector('img');
        gal.scrollBy({left:(+g.getAttribute('data-dir'))*((im?im.offsetWidth:gal.clientWidth)+8), behavior:'smooth'}); }
      return;
    }
    var el = e.target.closest('[data-adl]'); if(!el) return;
    var a = el.getAttribute('data-adl'), k = el.getAttribute('data-k'), q = +el.getAttribute('data-q');

    /* every action clears the note except undo — the note is about the
       action just taken, and a stale one is worse than none */
    if(a !== 'undo') NOTE = null;

    if(a==='close'){ close(); return; }
    if(a==='inc'){ change(k,q+1); return; }
    if(a==='dec' && q>1){
      var was = tins();
      change(k,q-1).then(function(){
        if(was>=ADL.giftAt && tins()<ADL.giftAt){ NOTE='One tin fewer &mdash; the free gifts are no longer in the box.'; render(); }
      });
      return;
    }
    if(a==='rm'){
      var it = CART.items.filter(function(x){ return x.key===k; })[0]; if(!it) return;
      var wasT = tins(); LAST = {id:it.variant_id, q:it.quantity};
      change(k,0).then(function(){
        NOTE = '<b>'+it.product_title+'</b> removed. <u data-adl="undo">Undo</u>'+
               ((wasT>=ADL.giftAt && tins()<ADL.giftAt) ? ' &mdash; the gifts went with it.' : '');
        render();
      });
      return;
    }
    if(a==='undo'){ if(LAST){ var l=LAST; LAST=null; NOTE=null; add(l.id, l.q); } return; }
    if(a==='add'){ QV=null; add(el.getAttribute('data-v')); return; }
    if(a==='qv'){ QV = el.getAttribute('data-h'); sheet(); return; }
    if(a==='gifts'){ QV = 'gifts'; sheet(); return; }
    if(a==='qvclose'){ QV = null; sheet(); return; }
    if(a==='expand'){ OPEN = true; MANUAL = true; render(); return; }
    if(a==='collapse'){ OPEN = false; MANUAL = true; render(); return; }
  });

  /* gallery dots follow the scroll */
  document.addEventListener('scroll', function(e){
    var g = e.target;
    if(g && g.classList && g.classList.contains('gal')){
      var i = Math.round(g.scrollLeft / g.clientWidth);
      var dots = QVS.querySelectorAll('.dots i');
      for(var j=0;j<dots.length;j++) dots[j].className = (j===i ? 'on' : '');
    }
  }, true);

  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    if(QV){ QV=null; sheet(); return; }
    if(root.classList.contains('open')) close();
  });
  document.addEventListener('DOMContentLoaded', load);
  window.adlCartDrawer = {open:open, close:close, reload:load, config:ADL};
})();
